/** @jsx jsx */
import { jsx } from '@emotion/react'

import { 
  sobreBanner,
  bannerContent
}  from '../assets/styles/PageBanner.styles'

const SobreBanner = ({ title, paragraph }) => {
  return (
    <section css={sobreBanner}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div css={bannerContent} className="banner_content text-center">
              <h1>{title}</h1>
              <p id="eduInfantil">{paragraph}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SobreBanner;
